/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const useAsset = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let id = urlParams.get("id");
    let group = urlParams.get("group");
    if (id) {
        id = String(id).trim();
    }
    if (group) {
        group = String(group).trim();
    }
    return {
        id,
        group,
    };
};
